<template>
  <div>
    <!--loader-->
    <div class="vld-parent">
      <loading loader='bars' :active.sync="isLoading" :can-cancel="true" :is-full-page="isFullPage">
      </loading>
    </div>
    <div class="page-header clear-filter"></div>
    <!--loader-->
    <div class="outer-wrapper">
      <div class="container">
        <div v-if="showPageContent" class="text-center">
          <h5 class="header-1"><b></b></h5>
          <img src="img/medco_offer.jpg" />
          <div class="dear-cust-div1" style="text-align:center;">
            <h3 style="margin:0;"></h3>
          </div>
          <div id="consent-data" class="dear-cust-div1" style="text-align:justify;margin:15px 0">
            <p> Dear {{userName}}, you will be purchasing your medicines through Medco Solutions Pvt Ltd website. If you
              agree then we will share your personal information with MedcoBox.<b> You will also get Rs 100/- cashback
                in your MedcoBox wallet. </b> <br />Note: Doodhvale does not sell any medicines on its platform. </p>
          </div>
          <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">
            <button mat-raised-button="" v-on:click.prevent="updateUserConsent()"
              class="mat-raised-button btn btn-info btn-round btn-lg dv-primary-btn" value=""><span
                class="mat-button-wrapper">I AGREE</span>
              <div class="mat-button-ripple mat-ripple" matripple=""></div>
              <div class="mat-button-focus-overlay"></div>
            </button>
          </div>
        </div>
        <div v-else class="text-center">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';
export default {
  components: {
    Loading
  },
  data() {
    return {
      apiUrl: 'https://doodhvale.in/dv/',
      userKey: '',
      userName: 'Customer',
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      showPageContent: false,
      applyCashBack: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const params = new URLSearchParams()
      params.append('action', 'fetch')
      var fullUrl = document.URL
      var splitKey = fullUrl.split('userKey=')
      var userKey = splitKey[1].split('&')
      var splitName = fullUrl.split('userName=')
      if (userKey[0] != null) {
        this.userKey = userKey[0]
        this.userName = splitName[1] ? _.capitalize(splitName[1]) : 'Customer'
        var f = _.capitalize(splitName[1])
        params.append('userKey', this.userKey)
        axios({
          url: this.apiUrl + 'doodhvale/api/web/v3' + '/vendors/vendor-user-info-or-update',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
          .then(response => {
            if (response.data.status === '000002') {
              this.showPageContent = true
            } else if (response.data.status === '000000') {
              this.fetchMedcoData()
            }
            else {
              this.showPageContent = true
            }
          })
          .catch(e => {
          })
        this.isLoading = false
      }
    },
    updateUserConsent() {
      this.isLoading = true
      const params = new URLSearchParams()
      params.append('action', 'update')
      params.append('userKey', this.userKey)
      var consentData = document.querySelector("#consent-data").innerHTML
      params.append('consentData', consentData)
      axios({
        url: this.apiUrl + 'doodhvale/api/web/v3' + '/vendors/vendor-user-info-or-update',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
        .then(response => {
          if (response.data.status === '000000') {
            // this.applyCashBack = true
            // debugger
            const paramsOffer = new URLSearchParams()
            paramsOffer.append('vendor_name', 'medcobox')
            // paramsOffer.append('action_name', 'firstorder_cashback')
            // paramsOffer.append('coupon_code', 'offer10x500') 
            paramsOffer.append('amount', 1)
            paramsOffer.append('is_verify', 0)
            paramsOffer.append('username', this.userKey)
            axios({
              url: this.apiUrl + 'doodhvale/api/web/v3' + '/vendors/vendor-cashback-offer',
              method: 'post',
              data: paramsOffer,
              withCredentials: false,
              headers: {
              }
            })
              .then(response => {
                // console.log(response)
                if (response.data.status === '000000') {


                }
                this.fetchMedcoData()

              })
              .catch(e => {
              })
            //this.fetchMedcoData()
          }
          else {
            this.showPageContent = true
          }

        })
        .catch(e => {
        })

      this.isLoading = false
    },
    fetchMedcoData() {
      this.isLoading = true
      const params = new URLSearchParams()
      params.append('user_number', this.userKey)
      axios({
        url: 'https://api.medcobox.in/api/v1/management/consumers/vendor/sso-login',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
          'Authorization': "Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kb3JfY29kZSI6IldTSEkifQ.eFiXUp8SDI28V4YJwJRYVQRWOhpaYL3Q3-mMrxkRw74"
        }
      })
        .then(response => {
          if (response.data.status == 0) {

            //if(this.applyCashBack == true){

            //}

            // location.replace(response.data.data.sso_url)
          } else {
            this.showPageContent = true
          }
        })
        .catch(e => {
        })
      this.isLoading = false
    }
  }
}
</script>
<style>
.membership p,
.bottomParaDiv p {
  text-align: justify;
}
</style>